import axios from "axios";
import { InitPage } from "../index";

declare var App: any;
declare var storeLocation: string;
declare var showInfoDialog;
declare var showErrorDialog;
declare var printJobs;
declare var perPage;
declare var currentPage;
declare var printedQty;
declare var selectAll;
declare var transferslipCreation;

class BulkPrint {
  printTemplateChannel: any;
  bulkPrintingChannel: any;
  // Guards the live progress channel against out-of-order / stale messages.
  // importInProgress is true only while an upload's AJAX request is in
  // flight; once that request's response (success or error) comes back,
  // further channel messages for it are ignored outright — closes the race
  // where a message can arrive after the authoritative AJAX response and
  // clobber it. lastProgress additionally rejects any message reporting a
  // lower progress than one already applied, in case messages for the same
  // import arrive out of order while it's still running.
  importInProgress: boolean = false;
  lastProgress: number = -1;

  init() {
    this.printTemplateChannel = this.connectToTemplate();
    this.bulkPrintingChannel = this.connectToBulkPrinting();
    this.htmlInitialize();
  }

  htmlInitialize() {
    let _this = this;
    $('.progressBarDiv').hide();

    $("#showImportFile").on("click", function() {
      $("#import_file").modal();
    });

    $('#hidePrintedLabels').change(function() {
      var checkbox = $(this);
      if (checkbox.prop('checked')) {
        document.cookie = `bulk_prints_${storeLocation}_hide_printed=1;path=/`;
      } else {
        document.cookie = `bulk_prints_${storeLocation}_hide_printed=0;path=/`;
      }
      _this.updatePrintTempalesData(true);
    });

    $('#importMethod').change(function() {
      var selected_method = $(this).val();
      var methods = ['standard', 'custom', 'custom_2', 'custom_3', 'custom_4', 'custom_catalog']
      methods.forEach(method => {
        if (method === selected_method) {
          $(`#${method}`).removeClass('hide');
        } else {
          $(`#${method}`).addClass('hide');
        }
      });
      _this.removeProgressDiv();
    });

    $('.print_tag_data').change(function() {
      var checkbox = $(this);
      if (checkbox.prop('checked')) {
        printJobs.push(parseInt(checkbox.attr('data')));
      } else {
        _this.removeFromArrayByValue(parseInt(checkbox.attr('data')));
        $('#selectAll').prop('checked', false);
        selectAll = false;
        $('#select_all').val(selectAll);
        document.cookie = `bulk_prints_${storeLocation}_select_all=0;path=/`;
      }
    });

    $("#importBtn").on("click", function() {
      $("#import_modal").modal();
    });

    const submitUploadButtons = ['#submitUpload', '#custom_submitUpload', '#custom_catalog_submitUpload', '#custom_2_submitUpload', '#custom_3_submitUpload', '#custom_4_submitUpload'];

    submitUploadButtons.forEach(button => {
      $(button).on('click', function() {
        $('#importMethod').prop('disabled', true);
      });
    });

    if ($('#selectAll').prop('checked')) {
      $('.print_tag_data').prop('checked', true);
      printJobs = [];
    }

    $('#selectAll').change(function() {
      var checkbox = $(this);
      if (checkbox.prop('checked')) {
        $('#select_all_modal').modal();
      } else {
        document.cookie = `bulk_prints_${storeLocation}_select_all=false;path=/`;
        $('.print_tag_data').prop('checked', false);
        selectAll = false;
        $('#select_all').val(selectAll);
        printJobs = [];
      }
    });

    $('#submitSelectAll').click(function() {
      var selectAllOption = $("input[name='select_all_options']:checked").val();
      console.log(selectAllOption);
      if (selectAllOption == 'all_pages') {
        $('.print_tag_data').prop('checked', true);
        selectAll = 'all_pages';
        document.cookie = `bulk_prints_${storeLocation}_select_all=all_pages;path=/`;
      } else if (selectAllOption == 'current_page') {
        $('.print_tag_data').prop('checked', true);
        selectAll = `page_${currentPage}`;
        document.cookie = `bulk_prints_${storeLocation}_select_all=page_${currentPage};path=/`;
      }

      $('#select_all').val(selectAll);
      $('#select_all_modal').modal('hide');
    });

    $('#closeSelectAll').click(function() {
      $('#selectAll').prop('checked', false);
    });


    $('.template-details').on('click', function() {
      var data = $(this).data('template');
      var receiving_date = $(this).data('receivingdate');
      var tbody = `
            <td>${data.container_qty || ''}</td>
            <td>${data.attr1 || ''} </td>
            <td>${data.attr2 || ''} </td>
            <td>${data.attr3 || ''} </td>
            <td>${data.attr4 || ''} </td>
            <td>${data.attr5 || ''} </td>
            <td>${data.attr6 || ''} </td>
            <td>${data.attr7 || ''} </td>
            <td>${data.attr8 || ''} </td>
            <td>${data.attr9 || ''} </td>
            <td>${data.attr10 || ''} </td>
            <td class="double-lines-content">${receiving_date} </td>
          `;
      $('#details-content').html(tbody);
      $('.show-template-details').modal('show');
    });

    $("#showCustomImportFile").on("click", function() {
      $("#custom_import_file").modal();
    });

    $("#selectAllBoxes").on("click", function() {
      $.each($(".print_tag_data"), function() {
        $(this).prop("checked", ((true as unknown) as string));
      });
    });

    $("#unSelectAllBoxes").on("click", function() {
      $.each($(".print_tag_data"), function() {
        $(this).prop("checked", ((false as unknown) as string));
      });
    });

    $("#upload_file_form").submit((e) => {
      e.preventDefault();
      _this.updateLoadingStatus(true);
      _this.importInProgress = true;
      _this.lastProgress = -1;
      _this.showInitialProgress();
      $("#importing_error").text('');
      $("#importing_error").hide();
      ($("#upload_file_form") as any).ajaxSubmit({
        url: $(this).attr("action"),
        type: "post",
        dataType: "JSON",
        success: (data) => {
          _this.updateLoadingStatus(false);
          _this.importInProgress = false;
          _this.finishProgressBar();
          $("#finished_status").show();
          $("#uploaded_status").show();
          $("#finished_stats").show();
          $("#finished_stats").html(`<i class="fa fa-check text-success"></i>Detected ${data.total_records} Records<br>${data.failed} Error(s) Found<br>${data.print_lines} Lines to Print<br>${data.tags} Tags to Print`);

          $(".totalCount").text(data.total_records);
          $(".skippedLines").text(data.failed);
          $(".importedLines").text(data.success);
          _this.renderSkippedLineCount('.skippedLinesDueToDuplicateAsset', data.duplicate_assets, data.duplicate_assets_errors_file);
          _this.renderSkippedLineCount('.skippedLinesDueToMissingItemsFromCatalog', data.invalid_item_numbers, data.invalid_item_numbers_errors_file);
          _this.renderSkippedLineCount('.skippedLinesDueToOtherReasons', data.invalid_items, data.invalid_items_errors_file);
          _this.renderSkippedLineCount('.skippedLinesDueToInvalidSgtin', data.invalid_sgtin, data.invalid_sgtin_errors_file);

          $("#submitUpload").hide();
          $("#proceedToPrinting").show();
          $("#proceedToPrinting").on("click", function() {
            window.location.reload();
          })
          // resetFileInput();
        },
        error: (xhr) => {
          _this.updateLoadingStatus(false);
          _this.importInProgress = false;
          _this.handleUploadError('importing_error', xhr);
        }
      });
    });

    $("#custom_upload_file_form").submit((e) => {
      e.preventDefault();
      _this.updateLoadingStatus(true);
      _this.importInProgress = true;
      _this.lastProgress = -1;
      _this.showInitialProgress();
      $("#custom_importing_error").text('');
      $("#custom_importing_error").hide();
      ($("#custom_upload_file_form") as any).ajaxSubmit({
        url: $(this).attr("action"),
        type: "post",
        dataType: "JSON",
        success: (data) => {
          _this.updateLoadingStatus(false);
          _this.importInProgress = false;
          _this.finishProgressBar();
          $("#custom_finished_status").show();
          $("#custom_uploaded_status").show();
          $("#custom_finished_stats").show();
          $("#custom_finished_stats").html(`<i class="fa fa-check text-success"></i>${data.total_records} Record(s) Detected<br>${data.failed} Error(s) Found<br>${data.print_lines} SKU added to the queue<br>${data.tags} Prints total`);
          $("#custom_submitUpload").hide();
          $("#customProceedToPrinting").show();
          $(".totalCount").text(data.total_records);
          $(".skippedLines").text(data.failed);
          $(".importedLines").text(data.success);
          _this.renderSkippedLineCount('.skippedLinesDueToDuplicateAsset', data.duplicate_assets, data.duplicate_assets_errors_file);
          _this.renderSkippedLineCount('.skippedLinesDueToMissingItemsFromCatalog', data.invalid_item_numbers, data.invalid_item_numbers_errors_file);
          _this.renderSkippedLineCount('.skippedLinesDueToOtherReasons', data.invalid_items, data.invalid_items_errors_file);
          _this.renderSkippedLineCount('.skippedLinesDueToInvalidSgtin', data.invalid_sgtin, data.invalid_sgtin_errors_file);

          $("#customProceedToPrinting").on("click", function() {
            window.location.reload();
          })
        },
        error: (xhr) => {
          _this.updateLoadingStatus(false);
          _this.importInProgress = false;
          _this.handleUploadError('custom_importing_error', xhr);
        }
      });
    });

    $("#showCustomCatalogPrintImportFile").on("click", function() {
      $("#custom_catalog_print_import_file").modal();
    });

    $("#custom_catalog_print_upload_file_form").submit((e) => {
      e.preventDefault();
      _this.updateLoadingStatus(true);
      _this.importInProgress = true;
      _this.lastProgress = -1;
      _this.showInitialProgress();
      $("#custom_catalog_print_importing_error").text('');
      $("#custom_catalog_print_importing_error").hide();
      ($("#custom_catalog_print_upload_file_form") as any).ajaxSubmit({
        url: $(this).attr("action"),
        type: "post",
        dataType: "JSON",
        success: (data: any) => {
          _this.updateLoadingStatus(false);
          _this.importInProgress = false;
          _this.finishProgressBar();
          $("#custom_catalog_print_finished_status").show();
          $("#custom_catalog_print_uploaded_status").show();
          $("#custom_catalog_print_finished_stats").show();
          $("#custom_catalog_print_finished_stats").html(`<i class="fa fa-check text-success"></i>${data.total_records} Record(s) Detected<br>${data.failed} Error(s) Found<br>${data.print_lines} SKU added to the queue<br>${data.tags} Prints total`);
          $("#custom_catalog_print_submit_upload").hide();
          $("#custom_catalog_print_proceed_to_printing").show();
          $(".totalCount").text(data.total_records);
          $(".skippedLines").text(data.failed);
          $(".importedLines").text(data.success);
          _this.renderSkippedLineCount('.skippedLinesDueToDuplicateAsset', data.duplicate_assets, data.duplicate_assets_errors_file);
          _this.renderSkippedLineCount('.skippedLinesDueToMissingItemsFromCatalog', data.invalid_item_numbers, data.invalid_item_numbers_errors_file);
          _this.renderSkippedLineCount('.skippedLinesDueToOtherReasons', data.invalid_items, data.invalid_items_errors_file);
          _this.renderSkippedLineCount('.skippedLinesDueToInvalidSgtin', data.invalid_sgtin, data.invalid_sgtin_errors_file);
          $("#custom_catalog_print_proceed_to_printing").on("click", function() {
            window.location.reload();
          })
        },
        error: (xhr) => {
          _this.updateLoadingStatus(false);
          _this.importInProgress = false;
          _this.handleUploadError('custom_catalog_print_importing_error', xhr);
        }
      });
    });

    $("#showCustom2ImportFile").on("click", function() {
      $("#custom2_import_file").modal();
    });

    $("#showCustom3ImportFile").on("click", function() {
      $("#custom3_import_file").modal();
    });

    $("#showCustom4ImportFile").on("click", function() {
      $("#custom4_import_file").modal();
    });

    $("#custom2_upload_file_form").submit((e) => {
      e.preventDefault();
      _this.updateLoadingStatus(true);
      _this.importInProgress = true;
      _this.lastProgress = -1;
      _this.showInitialProgress();
      $("#custom2_importing_error").text('');
      $("#custom2_importing_error").hide();
      ($("#custom2_upload_file_form") as any).ajaxSubmit({
        url: $(this).attr("action"),
        type: "post",
        dataType: "JSON",
        success: (data: any) => {
          _this.updateLoadingStatus(false);
          _this.importInProgress = false;
          _this.finishProgressBar();
          $("#custom2_finished_status").show();
          $("#custom2_uploaded_status").show();
          $("#custom2_finished_stats").show();
          $("#custom2_finished_stats").html(`<i class="fa fa-check text-success"></i>${data.total_records} Record(s) Detected<br>${data.failed} Error(s) Found<br>${data.print_lines} added to the queue<br>${data.tags} Prints total`);
          $("#custom2_submit_upload").hide();
          $("#custom2_proceed_to_printing").show();
          $(".totalCount").text(data.total_records);
          $(".skippedLines").text(data.failed);
          $(".importedLines").text(data.success);
          _this.renderSkippedLineCount('.skippedLinesDueToDuplicateAsset', data.duplicate_assets, data.duplicate_assets_errors_file);
          _this.renderSkippedLineCount('.skippedLinesDueToMissingItemsFromCatalog', data.invalid_item_numbers, data.invalid_item_numbers_errors_file);
          _this.renderSkippedLineCount('.skippedLinesDueToOtherReasons', data.invalid_items, data.invalid_items_errors_file);
          _this.renderSkippedLineCount('.skippedLinesDueToInvalidSgtin', data.invalid_sgtin, data.invalid_sgtin_errors_file);
          $("#custom2_proceed_to_printing").on("click", function() {
            window.location.reload();
          })
        },
        error: (xhr) => {
          _this.updateLoadingStatus(false);
          _this.importInProgress = false;
          _this.handleUploadError('custom2_importing_error', xhr);
        }
      });
    });

    $("#custom3_upload_file_form").submit((e) => {
      e.preventDefault();
      _this.updateLoadingStatus(true);
      _this.importInProgress = true;
      _this.lastProgress = -1;
      _this.showInitialProgress();
      $("#custom3_importing_error").text('');
      $("#custom3_importing_error").hide();
      ($("#custom3_upload_file_form") as any).ajaxSubmit({
        url: $(this).attr("action"),
        type: "post",
        dataType: "JSON",
        success: (data: any) => {
          _this.updateLoadingStatus(false);
          _this.importInProgress = false;
          _this.finishProgressBar();
          $("#custom3_finished_status").show();
          $("#custom3_uploaded_status").show();
          $("#custom3_finished_stats").show();
          $("#custom3_finished_stats").html(`<i class="fa fa-check text-success"></i>${data.total_records} Record(s) Detected<br>${data.failed} Error(s) Found<br>${data.print_lines} added to the queue<br>${data.tags} Prints total`);
          $("#custom3_submit_upload").hide();
          $("#custom3_proceed_to_printing").show();
          $(".totalCount").text(data.total_records);
          $(".skippedLines").text(data.failed);
          $(".importedLines").text(data.success);
          _this.renderSkippedLineCount('.skippedLinesDueToDuplicateAsset', data.duplicate_assets, data.duplicate_assets_errors_file);
          _this.renderSkippedLineCount('.skippedLinesDueToMissingItemsFromCatalog', data.invalid_item_numbers, data.invalid_item_numbers_errors_file);
          _this.renderSkippedLineCount('.skippedLinesDueToOtherReasons', data.invalid_items, data.invalid_items_errors_file);
          _this.renderSkippedLineCount('.skippedLinesDueToInvalidSgtin', data.invalid_sgtin, data.invalid_sgtin_errors_file);
          $("#custom3_proceed_to_printing").on("click", function() {
            window.location.reload();
          })
        },
        error: (xhr) => {
          _this.updateLoadingStatus(false);
          _this.importInProgress = false;
          _this.handleUploadError('custom3_importing_error', xhr);
        }
      });
    });

    $("#custom4_upload_file_form").submit((e) => {
      e.preventDefault();
      _this.updateLoadingStatus(true);
      _this.importInProgress = true;
      _this.lastProgress = -1;
      _this.showInitialProgress();
      $("#custom4_importing_error").text('');
      $("#custom4_importing_error").hide();
      ($("#custom4_upload_file_form") as any).ajaxSubmit({
        url: $(this).attr("action"),
        type: "post",
        dataType: "JSON",
        success: (data: any) => {
          _this.updateLoadingStatus(false);
          _this.importInProgress = false;
          _this.finishProgressBar();
          $("#custom4_finished_status").show();
          $("#custom4_uploaded_status").show();
          $("#custom4_finished_stats").show();
          $("#custom4_finished_stats").html(`<i class="fa fa-check text-success"></i>${data.total_records} Record(s) Detected<br>${data.failed} Error(s) Found<br>${data.print_lines} added to the queue<br>${data.tags} Prints total`);
          $("#custom4_submit_upload").hide();
          $("#custom4_proceed_to_printing").show();
          $(".totalCount").text(data.total_records);
          $(".skippedLines").text(data.failed);
          $(".importedLines").text(data.success);
          _this.renderSkippedLineCount('.skippedLinesDueToDuplicateAsset', data.duplicate_assets, data.duplicate_assets_errors_file);
          _this.renderSkippedLineCount('.skippedLinesDueToMissingItemsFromCatalog', data.invalid_item_numbers, data.invalid_item_numbers_errors_file);
          _this.renderSkippedLineCount('.skippedLinesDueToOtherReasons', data.invalid_items, data.invalid_items_errors_file);
          $("#custom4_proceed_to_printing").on("click", function() {
            window.location.reload();
          })
        },
        error: (xhr) => {
          _this.updateLoadingStatus(false);
          _this.importInProgress = false;
          _this.handleUploadError('custom4_importing_error', xhr);
        }
      });
    });

    $("#bulkPrint").submit((e) => {
      e.preventDefault();
      if (transferslipCreation == true) {
        $('#transferslipCreationModal').modal();
        return
      }

      this.do_print();

    });

    $('#stopButton').on('click', function() {
      $('#startButton').removeAttr('style');
      $(this).attr('style', 'display: none !important');
    });

    $('#transferslipCreation').submit((e) => {
      e.preventDefault();
      this.do_print();
      $('#transferslipCreationModal').modal('hide');
    });
  }

  do_print() {
    let ids: string[];
    ids = [];
    $.each($(".print_tag_data:checked"), function() {
      ids.push(($(this).val() as string));
    });
    $("#print_jobs").val(ids);
    $('#select_all').val(selectAll);
    $('#transferslip_creation').val($('#transferslipCreationModal input[name=type]:checked').val());
    $('#transferslip_to').val($('#transferslipCreationModal select[name=location]').val());
    $('#transferslip_document_id').val($('#transferslipCreationModal input[name=doc_num]').val());
    $('#transferslip_reason').val($('#transferslipCreationModal textarea[name=user_reason]').val());
    ($("#bulkPrint") as any).ajaxSubmit({
      url: $(this).attr("action"),
      type: "post",
      dataType: "JSON",
      success: (data) => {
        if (data.success == true) {
          $('#startButton').attr('style', 'display: none !important');
          $('#stopButton').show();
        }
        showInfoDialog(data.message);
      },
      error: (error) => {
        showErrorDialog(error.message);
      }
    });
  }

  connectToTemplate() {
    let _this = this;
    App.cable.subscriptions.create(
      // Connection configuration
      {
        channel: "PrintTemplateChannel",
        tenant_code: storeLocation
      },
      {
        connected() { console.log("'connected'") },
        disconnected() { /* Called when the subscription has been terminated by the server */ },
        received(data: any) {
          console.log(data);
          _this.updateStatus(data);
          _this.updateTemplateProgress(data);
        }
      }
    );
  }

  connectToBulkPrinting() {
    let _this = this;
    App.cable.subscriptions.create(
      // Connection configuration
      {
        channel: "BulkPrintChannel",
        tenant_code: storeLocation
      },
      // Pass in connection callbacks
      {
        connected() { /* Called when the subscription is ready for use on the server */ },
        disconnected() { /* Called when the subscription has been terminated by the server */ },
        received(data: any) {
          console.log(data);
          if (data.type == "progress") {
            _this.updatePrintProgress(data);
          } else if (data.type == "line") {
            _this.updateLineProgress(data);
          }
        }
      }
    );
  }

  updatePrintTempalesData(forceUpdate = false) {
    if (this.hidePrinted() || forceUpdate) {
      axios.get(`/${storeLocation.replace(/_/g, "/")}/bulk_prints.json`, { params: { print_jobs: printJobs } })
        .then((resp) => {
          $('#bulkPrintTemplatesTable').html(resp.data.content);
          $('#bulkPrintTemplatesPagination').html(resp.data.pagination);
          $('#bulkPrintTemplatesRemainingQty').html(resp.data.remaining_qty);
        })
        .catch(() => {
        });
    }
  }

  hidePrinted() {
    return this.getCookie(`bulk_prints_${storeLocation}_hide_printed`) == '1'
  }

  arrayToQueryString(arr) {
    return arr.map(value => `print_jobs[]=${encodeURIComponent(value)}`).join('&');
  }

  getCookie(name) {
    var cookiePattern = new RegExp("(?:(?:^|.*;)\\s*" + name + "\\s*\\=\\s*([^;]*).*$)|^.*$");
    return document.cookie.replace(cookiePattern, "$1");
  }

  removeFromArrayByValue(value) {
    const index = printJobs.indexOf(value);
    if (index !== -1) {
      printJobs.splice(index, 1);
    }
  }

  updatePrintProgress(data) {
    console.log(data);
    $("#job_progress").html(`<br/><span class='text-muted'> Last/Present Job at </span>${data.progress} of ${data.total}`)
    printedQty += 1;
    if (perPage > printedQty) {
      if (this.hidePrinted()) {
        $(`#${data.item_number}-tr`).hide();
      }
    } else {
      this.updatePrintTempalesData();
    }
  }

  updateLineProgress(data) {
    $(`#${data.item_number}-printTime`).text(data.time);
    $(`#${data.item_number}-status`).text(data.status);
    var remainingQty = $('#bulkPrintTemplatesRemainingQty').html();
    var parsedQty = parseInt(remainingQty);
    parsedQty = isNaN(parsedQty) ? 0 : Math.max(parsedQty - 1, 0);
    $('#bulkPrintTemplatesRemainingQty').html(
      parsedQty.toString()
    );
  }

  handleUploadError(elementId: string, xhr: any) {
    $('#importMethod').prop('disabled', false);
    const responseJSON = xhr && xhr.responseJSON;
    const message = responseJSON && responseJSON.errors
      ? responseJSON.errors
      : `Unexpected error${xhr && xhr.status ? ` (status ${xhr.status})` : ''}. The file may be too large or the server may be unavailable. Please try again.`;
    console.log(message);
    $(`#${elementId}`).html(`Error Detected Import cancelled! <br/> ${message}`);
    $(`#${elementId}`).show();
    $(".progressBarDiv").hide();
  }

  showInitialProgress() {
    // Shown the instant the upload starts, so the user sees progress right
    // away instead of a blank gap until the first channel message (or the
    // AJAX response) arrives.
    $(".progressBarDiv").show();
    $(".progress-bar").text('0%');
    $(".progress-bar").css("width", '0%');
    $('.progressBarText').text('Importing...');
    $(".totalCount").text('0');
    $(".skippedLines").text('0');
    $(".importedLines").text('0');
  }

  // The AJAX response is the authoritative signal that this import is
  // actually done — call this from every success handler. The channel's
  // own "progress: 100" broadcast travels over a separate connection with
  // no ordering guarantee against the AJAX response, so it can arrive late
  // or get dropped by the importInProgress guard, leaving the bar stuck
  // below 100% even though the real summary numbers already rendered.
  finishProgressBar() {
    $(".progress-bar").text('100%');
    $(".progress-bar").css("width", '100%');
    $('.progressBarText').text('Imported!');
  }

  updateLoadingStatus(loading) {
    if (loading) {
      $(".import_loading").show();
      $(".import_not_loading").hide();
    } else {
      $(".import_loading").hide();
      $(".import_not_loading").show();
    }
  }

  renderSkippedLineCount(selector: string, count: any, fileUrl: string) {
    if (count === undefined || count === null) {
      return;
    }
    if (fileUrl && Number(count) > 0) {
      $(selector).html(
        `<span class="skippedLineCount">${count}</span>` +
        `<a class="skippedLinesDownload pull-right" target="_blank" ` +
        `href="${encodeURI(fileUrl)}" title="Download the skipped lines as a CSV file">` +
        `Download</a>`
      );
    } else {
      $(selector).html(`<span class="skippedLineCount">${count}</span>`);
    }
  }

  updateStatus(data) {
    $("#uploaded_status").show();
    $("#imported_items_stat").html(`Imported ${data.success} of ${data.total_count}`)
  }

  updateTemplateProgress(data) {
    if (!this.importInProgress) {
      // This import's AJAX response already arrived and rendered the
      // authoritative final state — a message landing after that is stale
      // regardless of what progress value it carries, so ignore it.
      return;
    }
    if (this.lastProgress === 100) {
      // Already reached completion for this import — any further message
      // (a duplicate 100% broadcast, or a late one that slipped past the
      // importInProgress check) has nothing new to say. Ignore it.
      return;
    }
    if (typeof data.progress === "number" && data.progress < this.lastProgress) {
      // Out-of-order delivery: a message for an earlier point in this same
      // import arrived after one we already applied — ignore it rather than
      // regress the displayed state.
      return;
    }
    this.lastProgress = data.progress;

    $(".progressBarDiv").show();
    $(".progress-bar").text(`${data.progress}%`);
    $(".progress-bar").css("width", `${data.progress}%`);
    $(".totalCount").text(data.total_count);
    $(".skippedLines").text(data.failed);
    $(".importedLines").text(data.success);
    if (data.progress == 100) {
      $('.progressBarText').text('Imported!');
    }

    this.renderSkippedLineCount('.skippedLinesDueToDuplicateAsset', data.duplicate_assets, '');
    this.renderSkippedLineCount('.skippedLinesDueToOtherReasons', data.invalid_items, '');
    this.renderSkippedLineCount('.skippedLinesDueToMissingItemsFromCatalog', data.invalid_item_numbers, '');
    this.renderSkippedLineCount('.skippedLinesDueToInvalidSgtin', data.invalid_sgtin, '');
  }

  removeProgressDiv() {
    $(".progressBarDiv").hide();
    $(".progress-bar").text('0%');
    $(".progress-bar").css("width", '0%');
    $(".totalCount").text('0');
    $(".skippedLines").text('0');
    $(".importedLines").text('0');
    $('.progressBarText').text('');
    this.renderSkippedLineCount('.skippedLinesDueToDuplicateAsset', 0, '');
    this.renderSkippedLineCount('.skippedLinesDueToMissingItemsFromCatalog', 0, '');
    this.renderSkippedLineCount('.skippedLinesDueToOtherReasons', 0, '');
    this.renderSkippedLineCount('.skippedLinesDueToInvalidSgtin', 0, '');
  }
}

export function LoadPage() {
  InitPage("bulk_prints", () => {
    const rfid = new BulkPrint();
    rfid.init();
  });
}
